import firebaseAPI from 'firebase';
import * as firebaseUi from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
require('firebase/firestore')

const config = {
  apiKey: "AIzaSyCGD3uwrCL4D7uoan3wnZZUPWWrZ4CDbd4",
  authDomain: "great-hymns-of-faith.firebaseapp.com",
  projectId: "great-hymns-of-faith",
  storageBucket: "great-hymns-of-faith.appspot.com",
  messagingSenderId: "252625535932",
  appId: "1:252625535932:web:1f41d1f6f04527fc14a1b9",
  measurementId: "G-YQ718BZT7H"
};

// Initiailize the firebase App
firebaseAPI.initializeApp(config)

// Initialize the FirebaseUI Widget using Firebase.
var ui = new firebaseUi.auth.AuthUI(firebaseAPI.auth())

// Firestore config
var firestoreDatabase = firebaseAPI.firestore();
firestoreDatabase.enablePersistence()
  .then(function () {
    // console.log("Persistence Enabled")
  })
  .catch(function (err) {
    if (err.code == 'failed-precondition') {
      console.error("offline storage can't function when two tabs are open")
    } else if (err.code == 'unimplemented') {
      console.error("offline storage not supported")
    }
  });

export const firebase = firebaseAPI
export const signInUi = ui
export const firestore = firestoreDatabase
export const storage = firebaseAPI.storage()
